import React from "react";
import "./App.css";
import Routes from "./Routes";

// Let's say you want to add custom colors

function App() {
  return (
    <div>
      <Routes />
    </div>
  );
}

export default App;
